import service from "@/store/services/reseller-products-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  resellerProduct: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, resellerProduct) => {
    state.resellerProduct = resellerProduct;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((resellerProduct) => {
      commit("SET_RESOURCE", resellerProduct);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((resellerProduct) => {
      commit("SET_RESOURCE", resellerProduct);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((resellerProduct) => {
      commit("SET_RESOURCE", resellerProduct);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  resellerProduct: (state) => state.resellerProduct,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((resellerProduct) => ({
      id: resellerProduct.id,
      name: resellerProduct.name,
    }));
  },
};

const resellerProducts = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default resellerProducts;
